"use client";

import { useState } from "react";
import { CreditCard, Loader2 } from "@/components/icons";
import { Button } from "@/components/ui/button";

interface BuyNowButtonProps {
  onBuy: () => Promise<void>;
  disabled?: boolean;
  label?: string;
}

export function BuyNowButton({
  onBuy,
  disabled = false,
  label = "Buy now",
}: BuyNowButtonProps) {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Button
      variant="primary"
      type="button"
      size="default"
      className="w-full"
      disabled={isLoading || disabled}
      onClick={async () => {
        setIsLoading(true);
        try {
          await onBuy();
        } finally {
          setIsLoading(false);
        }
      }}
    >
      {isLoading ? (
        <Loader2 className="size-4 animate-spin" />
      ) : (
        <CreditCard className="size-4" />
      )}
      {label}
    </Button>
  );
}
